import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  CardHeader,
  CardBody,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";

const Instructions = () => {
  const [testData, setTestData] = useState(null);
  const [instructions, setInstructions] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  // const location = useLocation();
  const navigate = useNavigate();

  const modelId = localStorage.getItem("test_id");
  useEffect(() => {
    fetchInstructions();
  }, []);

  const fetchInstructions = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/model-paper-instructions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // ✅ important!
          },
          body: JSON.stringify({
            id: modelId,
          }),
        }
      );

      const data = await res.json(); // ✅ parse JSON

      console.log("instructions", data);

      if (data.status === "1") {
        setInstructions(data.data.description || "");
        setTestData(data.data); // make sure testData is also set
      } else {
        setInstructions("No instructions available.");
      }
    } catch (error) {
      console.error("Error fetching instructions:", error);
      setInstructions("Error loading instructions.");
    }
  };

  const handleStartTest = () => {
    if (testData) {
      localStorage.setItem("test_id", testData.id);
      navigate("/demo-exam");
    }
  };

  const handleGoBack = () => {
    navigate("/test-series");
  };

  if (!testData) {
    return <div>Loading...</div>;
  }

  return (
    <section className="instructions-page">
      <div className="page_header"></div>
      <Container className="py-5">
        <Card className="justify-content-center">
          <CardHeader className="bg_light p-2 fw-bold">
            Test Instructions
          </CardHeader>
          <CardBody>
            <div className="mb-4">
              <h4 className="mb-2">Test Details</h4>
              <Row>
                <Col md={4}>
                  <p>
                    <strong>Test Name:</strong> {testData.title}
                  </p>
                  <p>
                    <strong>Type:</strong> {testData.package_name}
                  </p>
                </Col>
                <Col md={4}>
                  <p>
                    <strong>Total Marks:</strong> {testData.total_marks}
                  </p>
                  <p>
                    <strong>Passing Marks:</strong> {testData.passing_marks}
                  </p>
                </Col>
                <Col md={4}>
                  <p>
                    <strong>Duration:</strong> {testData.duration_minutes} mins
                  </p>
                  <p>
                    <strong>Total Questions:</strong> {testData.total_questions}
                  </p>
                </Col>
              </Row>
            </div>

            <hr />

            <div className="my-4">
              <h4 className="mb-3">Instructions</h4>
              <div
                className="instructions-content p-3 border rounded bg-light"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    instructions || "No instructions provided."
                  ),
                }}
              />
            </div>
            <div className="mb-4 d-flex gap-2 align-items-start">
              <input
                type="checkbox"
                id="agree-checkbox"
                className="mt-1"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <label htmlFor="agree-checkbox">
                I have read and understood the instructions. All Computer
                Hardwares allowed to me are in proper working condition. I agree
                that I am not carrying any prohibited gadget like mobile phone
                etc. / any prohibited material with me into the exam hall. I
                agree that in case of not adhering to the instructions, I will
                be disqualified from the exam.
              </label>
            </div>

            <div className="d-flex justify-content-between mt-4">
              <button className="educate-btn bg-primary" onClick={handleGoBack}>
                <span className="educate-btn__curve"></span>
                Go Back
              </button>
              <button
                onClick={handleStartTest}
                disabled={!isChecked}
                className="educate-btn"
              >
                Start Test
                <span className="educate-btn__curve"></span>
              </button>
            </div>
          </CardBody>
        </Card>
      </Container>
    </section>
  );
};

export default Instructions;
